import React, { useContext } from "react";
import ErrorResources from "../../../Components/ErrorResources";
import LocalizationContext from "../../../Localization/LanguageContext";
import { ILocalizationContext } from "../../../Localization/Models/ILocalizationContext";
import { LandingPage } from "../../../Components/LandingPage/LandingPage";

const Denied = () => {
    const { getValue } = useContext(LocalizationContext) as ILocalizationContext;
    return (
            <LandingPage
                iconProps={{ icon: "octagon-exclamation", size: "xxl"}}
                headingProps={{
                    center: true,
                    children: getValue('Denied', 'TitleError')
                }}
                description={
                    <>
                        <div className="error-resources">
                            {getValue('Denied', 'TitleSub')}
                        </div>
                        <ErrorResources />
                    </>
                }
            />
    );
}

export default Denied;